<template>
  <div class="content">
    <!-- 筛选 -->
    <div style="overflow: hidden">
      <el-input v-model="input1"
                placeholder="请输入产品编号"
                style="width:300px;margin-right: 20px;float: left"
                clearable>
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="loadFormData" />
      </el-input>
      <el-input v-model="input2"
                placeholder="请输入产品描述"
                style="width:300px;margin-right: 20px;float: left"
                clearable>
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="loadFormData" />
      </el-input>

      <el-select v-model="value"
                 placeholder="请选择"
                 @change="loadFormData"
                 style="float: left">
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleAdd"
                 type="success"
                 size="medium"
                 icon="el-icon-circle-plus-outline"
                 class="addBtn">发布APP
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table  v-loading="loading"
               :data="versionData.data"
              style="margin: 10px 0 15px 0;"
              :height="tableHt"
              border
              size="small"
              :highlight-current-row="true">
      <el-table-column label="序号"
                       type="index"></el-table-column>
      <el-table-column label="产品编号"
                       width="120"
                       prop="fName"
                       align="center" />
      <el-table-column label="产品描述"
                       width="120"
                       prop="fAlias"
                       align="center" />
      <el-table-column label="运行环境"
                       width="100"
                       align="center"
                       prop="fEnv"
                       :filters="[{ text: '正式环境', value: 1 }, { text: '测试环境', value: 0 }]"
                       :filter-multiple="false"
                       filter-placement="bottom-end"
                       :filter-method="filterevn">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.fEnv==0"
                  type="success"
                  size="small">测试环境
          </el-tag>
          <el-tag v-if="scope.row.fEnv==1"
                  type="danger"
                  size="small">正式环境
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="安装包地址"
                       prop="fPath"
                       align="left"
                       header-align="center"
                       :show-overflow-tooltip="true" />
      <el-table-column label="平台"
                       width="80"
                       prop="fPlatform"
                       align="center"
                       :formatter="(row, column, cellValue, index)=>cellValue==='1' ? 'android' : 'ios'" />
      <el-table-column label="版本号"
                       width="100"
                       prop="fVersion"
                       align="center" />
      <el-table-column label="强制更新"
                       width="80"
                       prop="fForce"
                       align="center"
                       :formatter="(row, column, cellValue, index)=>cellValue==='1' ? '是' : '否'" />
      <el-table-column label="创建日期"
                       width="100"
                       prop="fCreatetime"
                       align="center"
                       :formatter="formatDate" />
      <el-table-column label="操作"
                       width="400"
                       align="center">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="primary" @click="handlePluginManage(scope.row)">插件配置</el-button> -->
          <el-button size="mini"
                     type="primary"
                     @click="handlePluginManage(scope.row)">二维码
          </el-button>
          <el-button size="mini"
                     type="primary"
                     @click="handlePublish(scope.$index, scope.row)">发布版本
          </el-button>
          <el-button size="mini"
                     type="info"
                     @click="handleHistoryVersion(scope.$index, scope.row)">历史版本
          </el-button>
          <el-button size="mini"
                     type="danger"
                     @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination background
                   style="display: flex;justify-content: center"
                   layout="prev, pager, next"
                   :page-count="versionData.pageTotal"
                   :current-page.sync="versionData.curPage"
                   @current-change="loadFormData"
                   :page-size="versionData.pageSize"></el-pagination>

    <el-dialog :title="title"
               :visible.sync="addDlg"
               top="60px">
      <el-form :model="curAppConfig"
               label-width="120px"
               v-if="addDlg"
               label-suffix="：">

        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称"
                          :rules="{required: true, message: '产品名称不能为空', trigger: 'blur'}">
              <!--              :prop="fName"-->
              <el-input v-model="curAppConfig.fName"
                        :readonly="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="别名">
              <!--              :prop="fAlias"-->
              <el-input v-model="curAppConfig.fAlias"
                        :readonly="readonly"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="版本号"
                          :rules="{required: true, message: '版本号', trigger: 'blur'}">
              <el-input v-model="curAppConfig.fVersion"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="安装包">-->
<!--              <el-radio-group v-model="selectedType">-->
<!--                <el-radio label="address">输入地址</el-radio>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row v-if="selectedType == 'address'">
          <el-col :span="24">
            <el-form-item label="安装包地址" :rules="{required: true, message: '安装包地址', trigger: 'blur'}">
              <!--              :prop="fPath"-->
              <el-input v-model.trim="curAppConfig.fPath">
<!--                <el-button slot="append" @click="checkUrl">检测地址</el-button>-->
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="selectedType == 'upload'">
          <el-col :span="12">
            <el-form-item label="对象存储"
                          prop="version">
              <el-select v-model="curAppConfig.storageId"
                         placeholder="请选择"
                         style="float: left">
                <el-option v-for="item in storages"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-upload ref="upload"
                       action="/appconfig/t/app/publish"
                       :data="curAppConfig"
                       name="apk"
                       :multiple="false"
                       :auto-upload="false"
                       :on-success="uploadSuccess"
                       :on-error="uploadError">
              <el-button type="success"
                         slot="trigger"
                         size="small">上传文件
              </el-button>
            </el-upload>
          </el-col>
        </el-row>
        <el-row v-if="!readonly">
          <el-col :span="12">
            <el-form-item label="手机平台"
                          style="text-align:left">
              <el-radio v-model="curAppConfig.fPlatform"
                        label="1">android
              </el-radio>
              <el-radio v-model="curAppConfig.fPlatform"
                        label="2">ios
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="运行环境"
                          style="text-align: left"
                          :rules="{required: true, message: '请选择环境', trigger: 'blur'}">
              <el-select v-model="curAppConfig.fEnv"
                         :disabled="readonly">
                <el-option label="正式环境"
                           :value="1"></el-option>
                <el-option label="测试环境"
                           :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="强制更新"
                          style="text-align:left">
              <el-radio v-model="curAppConfig.fForce"
                        label="1">是
              </el-radio>
              <el-radio v-model="curAppConfig.fForce"
                        label="0">否
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="更新日志">
              <el-input v-model="curAppConfig.fLog"
                        type="textarea"
                        :rows="8"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="addDlg = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleSave">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="历史版本"
               :visible.sync="historyLog"
               top="20px"
               width="1000px"
               custom-class="historyDlg">
      <el-table :data="historyData"
                size="small"
                height="calc(100vh - 220px)">
        <el-table-column label="序号"
                         type="index"></el-table-column>
        <el-table-column label="地址"
                         prop="fPath"
                         align="left"
                         header-align="center"
                         :show-overflow-tooltip="true" />
        <el-table-column label="平台"
                         width="80"
                         prop="fPlatform"
                         align="center"
                         :formatter="(row, column, cellValue, index)=>cellValue==='1' ? 'android' : 'ios'" />
        <el-table-column label="版本号"
                         width="120"
                         prop="fVersion"
                         align="center" />
        <el-table-column label="强制更新"
                         width="80"
                         prop="fForce"
                         align="center"
                         :formatter="(row, column, cellValue, index)=>cellValue==='1' ? '是' : '否'" />
        <el-table-column label="创建日期"
                         width="120"
                         prop="fCreatetime"
                         align="center"
                         :formatter="formatDate" />
        <el-table-column label="操作"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="primary"
                       @click="handleHistoryEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button size="mini"
                       type="danger"
                       @click="handleDeleteHistory(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="small"
                   @click="historyLog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="二维码"
               :visible.sync="pluginManageDlg"
               top="60px"
               width="450px">
      <!--      <el-transfer filterable-->
      <!--        :titles="['插件列表', '已选中']"-->
      <!--        :filter-method="filterMethod"-->
      <!--        filter-placeholder="请输入关键词"-->
      <!--        v-model="selectedPluginList"-->
      <!--        :data="pluginData">-->
      <!--      </el-transfer>-->
      <img style="width: 400px;height: 400px;"
           :src="qrCodeUrl"
           alt="">
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="pluginManageDlg = false">关闭</el-button>
        <!--        <el-button type="primary"-->
        <!--          @click="handlePluginManageSave">保 存</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import util from "../lib/util.js";
import AppPublishService from "../Service/AppPublishService";
import { list as getStorageList } from "../Service/storageManage";
import { getAllPageList, findAppPlugins, addAppPlugins, addAppVersionData } from "../Service/pluginManage";
import _ from "lodash";
import { getQuerColdeUrl } from "@/Service/loginApi";

export default {
  data() {
    return {
      loading:false,
      title: "",
      mode: "add",
      addDlg: false,
      selectedType: "address",
      curAppConfig: {
        fName: "",
        fForce: "1",
        fPlatform: "1",
        fAlias: "",
        fPath: "",
        storageId:null
      },
      versionData: {
        curPage: 1,
        pageSize: 20,
        data: [],
        pageTotal: 1
      },
      historyLog: false,
      value: null,
      historyData: [],
      storages: [],
      options: [
        {
          label: "全部"
        },
        {
          value: "0",
          label: "测试环境"
        },
        {
          value: "1",
          label: "正式环境"
        }
      ],
      input1: null,
      input2: null,
      pluginManageDlg: false,
      selectedPluginList: [],
      pluginData: [],
      qrCodeUrl: "",
      // isUrlCorrect: false
      isUrlCorrect: true
    };
  },
  mounted() {
    this.loadFormData();
  },
  computed: {
    readonly() {
      return (this.title === "发布新版本" ? true : false) || this.mode === "edit";
    },
    tableHt() {
      return "calc(100vh - 190px)";
    }
  },
  methods: {
    filterevn(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    handlePublish(index, row) {
      this.mode = "add";
      this.curAppConfig = Object.assign({}, row, { fId: "" });
      this.title = "发布新版本";
      this.curAppConfig.fVersion = "";
      this.curAppConfig.fLog = "";
      // this.isUrlCorrect = false;
      this.isUrlCorrect = true;
      this.addDlg = true;
    },
    checkUrl() {
      const that = this;
      fetch(this.curAppConfig.fPath, { method: "HEAD" }).then(res => {
        if (res.ok) {
          that.isUrlCorrect = true;
          that.$message.success("安装包地址合法！");
        } else {
          that.isUrlCorrect = false;
          that.$message.error("安装包地址不存在！");
        }
      }).catch(e => {
        that.$message.error("安装包地址不存在！");
      });
    },

    handleHistoryVersion(index, row) {
      AppPublishService.getHistory(row.fName).then((r) => {
        this.historyData = r.data.data;
        this.historyLog = true;
      });
    },

    handleDelete(index, data) {
      this.$confirm("此操作将删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        util
          .delete(`/appconfig/t/app/publish/all/${data.fId}`)
          .then((r) => {
            if (r.data.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.loadFormData();
            } else {
              this.$message.error(r.data.message);
            }
          })
          .catch((r) => this.$message.error(r.data.message));
      });
    },

    handleDeleteHistory(index, data) {
      this.$confirm("此操作将删除该历史配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        util
          .delete(`/appconfig/t/app/publish/${data.fId}`)
          .then((r) => {
            if (r.data.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.handleHistoryVersion(null, data);
            } else {
              this.$message.error(r.data.message);
            }
          })
          .catch((r) => this.$message.error(r.data.message));
      });
    },

    handleHistoryEdit(index, row) {
      this.mode = "edit";
      this.curAppConfig = Object.assign({}, row);
      this.title = "修改版本信息";
      this.addDlg = true;
    },

    handleAdd() {
      this.mode = "add";
      this.curAppConfig = {
        fForce: "1",
        fPlatform: "1"
      };
      this.title = "发布APP";
      this.addDlg = true;
    },

    uploadSuccess(res) {
      if (res.code !== 200) return this.$message.error(res.message);
      this.$message({
        message: "保存成功",
        type: "success"
      });
      this.addDlg = false;
      this.curAppConfig = {};
      if (this.mode === "edit") {
        this.handleHistoryVersion(null, res);
      }
      this.loadFormData();
    },

    uploadError() {
      this.$message.error("保存失败");
    },

    handleSave() {
      if (!this.isUrlCorrect) {
        this.$message.error("请检查安装包地址是否正确！");
        return;
      }
      if (!this.curAppConfig?.fName) {
        this.$message.error("产品名称不能为空");
        return;
      }
      if (!this.curAppConfig?.fAlias) {
        this.$message.error("产品别名不能为空");
        return;
      }
      if (!this.curAppConfig?.fVersion) {
        this.$message.error("版本号不能为空");
        return;
      }
      if (!this.curAppConfig?.fEnv && this.curAppConfig?.fEnv !== 0) {
        this.$message.error("请选择环境");
        return;
      }
      let apkFile = null;
      if (this.mode === "add") {
        //新增版本
        if (this.selectedType === "upload") {
          this.curAppConfig.fPath = "";
          // 清理文件地址
          if (this.$refs.upload.uploadFiles.length < 1) {
            this.$message.error("请选择上传的APK文件");
            return;
          }
          apkFile = this.$refs.upload.uploadFiles[0].raw;
        } else if (this.selectedType === "address") {
          this.curAppConfig.uploadFiles = null;
          // 清理文件
          if (this.curAppConfig.fPath.length < 1) {
            this.$message.error("请输入版本文件地址");
            return;
          }
        }

        this.curAppConfig.storageId = null;
        let params = { ...this.curAppConfig, apk: apkFile };
        addAppVersionData(params).then(res => {
          this.uploadSuccess(res);
        }).catch((r) => this.uploadError());
        // this.$refs.upload.submit();
      } else {
        //修改记录版本
        let data = this.curAppConfig;
        if (this.$refs.upload.uploadFiles.length < 1) {
          AppPublishService.update(this.curAppConfig)
            .then((r) => this.uploadSuccess(this.curAppConfig))
            .catch((r) => this.uploadError());
        } else {
          this.$refs.upload.submit();
        }
      }
    },

    formatDate(row, column, cellValue, index) {
      return util.formatDate(cellValue);
    },

    // 添加APPConfig数据
    addConfig() {
      this.curAppConfig.fCreatetime = new Date();
      util.post("/t/appconfig", this.curAppConfig).then((r) => {
        if (r.data.code === 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.loadFormData();
          this.addDlg = false;
        } else {
          this.$message.error(r.data.message);
        }
      });
    },

    // 加载appConfig表格数据
    loadFormData() {
      // getStorageList().then((res) => {
      //   if (res.status === "FAILURE") {
      //     this.$message.error(res.errorMessage);
      //   } else {
      //     this.storages = res.data;
      //   }
      // });
      this.loading = true;
      AppPublishService.getApkList({
        page: this.versionData.curPage,
        size: this.versionData.pageSize,
        env: this.value,
        name: this.input1,
        alias: this.input2
      })
        .then((r) => {
          if (r.data.code === 200) {
            this.versionData.data = r.data.data.list;
            this.versionData.pageTotal = r.data.data.lastPage;
          } else {
            this.$message.error(r.data.message);
          }
        })
        .catch((r) => console.log(r)).finally(()=>{
          this.loading = false;
      }) ;
    },
    getPluginList(env) {
      getAllPageList({ env }).then((res) => {
        this.pluginData = res.data.map((r) => {
          r.key = r.fId;
          r.label = `${r.fName}(${r.fVersion})`;
          // r.nameVersion = `${r.fName}(${r.fVersion})`
          return r;
        });
        console.log(this.pluginData);
      });
    },
    getAppBindedPlugins(row) {
      findAppPlugins({ proId: row.fName, version: row.fVersion }).then((res) => {
        this.selectedPluginList = res.data?.map((r) => r.fId);
      });
    },
    filterMethod(query, item) {
      return item.fName.indexOf(query) > -1;
    },
    handlePluginManage(row) {
      // this.getPluginList(row.fEnv);
      // this.getAppBindedPlugins(row);
      getQuerColdeUrl(row.fName).then((res) => {
        if (res.status === 200) {
          // this.qrCodeUrl=res.data;
          const imageUrl = URL.createObjectURL(res.data);
          this.qrCodeUrl = imageUrl;
        }
      });
      this.pluginManageDlg = true;
      // this.curAppConfig = _.cloneDeep(row);
    },
    handlePluginManageSave() {
      let names = [];
      let existName = "";
      this.pluginData.forEach((r) => {
        if (this.selectedPluginList.includes(r.fId)) {
          if (!names.includes(r.fName)) {
            names.push(r.fName);
          } else {
            existName = r.fName;
          }
        }
      });
      if (existName) return this.$message.error(`选中插件【${existName}】存在版本重复，请检查！`);
      const { fName: proId, fVersion: proVersion } = this.curAppConfig;
      addAppPlugins({ proId, proVersion, plugins: this.selectedPluginList.join(",") }).then((res) => {
        if (res.code === 200) {
          this.pluginManageDlg = false;
          this.$message.success("操作成功!");
        }
      });
    }
  }
};
</script>
<style scoped>
.content >>> .addBtn {
  display: block;
  float: right;
}

.content {
  width: calc(100vw - 40px);
  height: 100%;
  padding: 20px 20px 10px 20px;
  background-color: #fff;
}

::v-deep .historyDlg {
  margin-bottom: 20px;
}
</style>

